/* with love from shopstory */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// Sorry for this name
function isTrulyResponsiveValue(x) {
  return typeof x === "object" && x !== null && !Array.isArray(x) && x.$res === true;
}

exports.isTrulyResponsiveValue = isTrulyResponsiveValue;
